import { IconProps } from "@mui/material";

const buttonStyle = {fontSize: "small"};


export default buttonStyle;